module.exports = __webpack_public_path__ + "static/media/1-square-unavailable.50b7bd63.svg";